<template>
    <b-form-group
            class="c-text"
            :description="description"
            :label="label"
            :label-for="id"
            :label-cols="labelCols"
            :aria-describedby="id + '_InvalidFeedback'">
        <Request
                ref="request"
                method="GET"
                :onRequestSuccess="requestSuccess"
                :onRequestError="requestError"
                :options="{
                        showAlert: true,
                        blockOnProcessing: false,
                        blockTransparent: false,
                        blockImg: '',
                        blockSpinner: 'wave'
                }"
                :root="root">
            <slot slot="body">
                <InputSelect
                        v-if="dataLoading === false"
                        v-model="dataValue"
                        :options="dataCountries"></InputSelect>
                <label v-else>{{Core.Definition.getDefinition('Chargement ...')}}</label>
            </slot>
        </Request>
        <b-form-invalid-feedback :id="id + '_InvalidFeedback'">
            {{invalidFeedbackMessage}}
        </b-form-invalid-feedback>
    </b-form-group>

</template>

<script>
    import InputSelect from "./InputSelect"
    import Request from './Request'
    export default {
        name: 'InputCountry',
        extends: InputSelect,
        components: {
            InputSelect,
            Request
        },
        props: {
            root: {
                type: String,
                default: '/geolocation'
            },
            onRetrieve: {
                type: Function,
                default: function() {
                    return false
                }
            },
            onPostSuccess: {
                type: Function,
                default: function() {
                    return false
                }
            },
            description: {
                type: String,
                default: ''
            },
            labelCols: {
                type: Number,
                default: 0
            },
            invalidFeedbackMessage: {
                type: String,
                default: ''
            },
            form: {
                type: Object,
                default: function() {return {}}
            },
            fieldRefs: {
                type: Array,
                default: function() { return [] }
            }
        },
        watch: {
            value(val) {
                this.dataValue = val
            },
            dataValue(val) {
                this.$emit('input', val)
            }
        },
        mounted() {
            this.init()
        },
        data: () => {
            return {
                App: window.App,
                dataValue: null,
                dataSelectedValue: null,
                dataCountries: [],
                dataLoading: false
            }
        },
        methods: {
            init() {
                this.dataValue = this.value
                this.retrieve()
            },
            retrieve() {
                this.dataLoading = true
                this.onRetrieve()
                this.$refs.request.clearArgs()
                this.$refs.request.request()
            },
            requestSuccess(data) {
                if (undefined !== data.countries) {
                    if (this.dataValue != null && this.dataValue.value === undefined) {
                        this.dataValue = window.Core.Select.select(this.dataValue, data.countries)
                    }
                    this.dataCountries = data.countries
                }
                this.dataLoading = false
                this.onPostSuccess(data)
            },
            requestError(data) {
            }
        }
    }
</script>